'use client'

// Súper sin productos todavía. Tema de la tienda pública (`--ms-*`), no el EmptyState del
// panel (que pinta `--redy-*`). Conserva `id="menu"` para el ancla de la portada.
import { useTranslations } from 'next-intl'

export function MarketEmpty() {
  const t = useTranslations('public.microsite.grocery.sections')
  return (
    <section id="menu" className="scroll-mt-20 px-5 sm:px-8 pt-8 sm:pt-12 pb-6 max-w-6xl mx-auto">
      <div
        className="rounded-2xl border px-6 py-12 text-center"
        style={{ borderColor: 'var(--ms-border)', background: 'var(--ms-bg)' }}
      >
        <div aria-hidden="true" className="text-3xl mb-3">🛒</div>
        <p className="text-[15px] font-semibold" style={{ color: 'var(--ms-text)' }}>
          {t('emptyTitle')}
        </p>
      </div>
    </section>
  )
}
